// organization.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { OrganizationActions } from '../actions/organization.actions';
import { initialState } from '../states/organization.state';

export const organizationReducer = createReducer(
  initialState,
  on(OrganizationActions.loadOrganization, (state) => ({ ...state, loading: true })),
  on(OrganizationActions.loadOrganizationSuccess, (state, { organizationList }) => ({
    ...state,
    loading: false,
    organizationList,
  })),
  on(OrganizationActions.createOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizationList: [organization, ...state.organizationList]
  })),
  on(OrganizationActions.editOrganizationSuccess, (state, { organization }) => ({
    ...state,
    // Merge into the existing org so fields like creationTime/createdTimestamp
    // (used for sorting) are preserved even when the API response omits them.
    organizationList: state.organizationList.map((org: any) =>
      org.id === organization?.id ? { ...org, ...organization } : org
    )
  })),
  on(OrganizationActions.deleteOrganizationSuccess, (state, { organizationId }) => ({
    ...state,
    organizationList: state.organizationList.filter((org) => org.id !== organizationId)
  })),
  on(OrganizationActions.loadOrganizationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
